module.exports = __webpack_public_path__ + "img/icon3.fea513e7.png";